import { render, staticRenderFns } from "./customerbodyright.vue?vue&type=template&id=3fcf4f42&scoped=true"
import script from "./customerbodyright.vue?vue&type=script&lang=js"
export * from "./customerbodyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf4f42",
  null
  
)

export default component.exports